import {Action, lazyGet} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {ILeaderboard} from "@dp-instant/social";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";

@injectable()
export class SubmitContextScoreAction extends Action {
    @inject(TypesGame.model)
    protected model: GameModel;

    async execute() {
        const {meta, social, currentContinent} = this.model;

        const ctxId = social.context_id;
        if (ctxId && !social.inSolo) {
            const contextLeaderboard = lazyGet<ILeaderboard>(TypesSocial.leaderboardContext);
            contextLeaderboard?.submit(social.me.scoreContext + 1, currentContinent.getHistory());
        }
    }
}
